module.exports = __webpack_public_path__ + "static/img/hm_loop_card_05.05bcd3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/healthMonitoring/hm_loop_card_05.png
// module id = C28l
// module chunks = 1